export default "__VITE_ASSET__D_Rve3K$__"